module.exports = "<ota-dialog disbledClose=\"true\" class=\"dialog-alert\">\n\n  <!-- contnet -->\n  <div class=\"dialog-success-content\">\n    <div class=\"box-success\">\n      <span class=\"icon-service-failed\"></span>\n    </div>\n    <p class=\"font-16px color-main body-text\" [ngClass]=\"{'mb-0': subText}\">{{text}}</p>\n    <p *ngIf=\"subText\" class=\"color-sub\">{{subText}}</p>\n    <div class=\"action-button\">\n      <button class=\"ota-btn-main\" md-dialog-close>{{'btn-ok' | translate}}</button>\n    </div>\n  </div>\n\n</ota-dialog>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modal/dialog-error/dialog-error.component.html
// module id = 1051
// module chunks = 22